/* @ngInject */
function InvitationFactory($http, $rootScope, moment) {
  class Invitation {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/invitations`;
    }

    static query() {
      return $http
        .get(Invitation.getResourceUrl())
        .then((response) => response.data.map((invitationData) => new Invitation(invitationData)));
    }

    isNew() {
      return !this._id;
    }

    lastSendSameDay() {
      return moment().isSame(moment(this.date), "day");
    }

    create() {
      if (!this.isNew()) throw new Error("The invitation is already sent");

      return $http.post(Invitation.getResourceUrl(), this).then((response) => angular.extend(this, response.data));
    }

    resend() {
      if (this.lastSendSameDay()) throw new Error("Inviting not allowed same day");

      return $http
        .put(`${Invitation.getResourceUrl()}/${this._id}`)
        .then((response) => angular.extend(this, response.data));
    }

    remove() {
      return $http.delete(`${Invitation.getResourceUrl()}/${this._id}`).then(() => true);
    }
  }

  return Invitation;
}

export default InvitationFactory;
